/**
 * @description
 * Path of image used in the application.
 */
export const PATH_SIGN_IN_BACKGROUND = '/asset/Image/signIn/background.svg';
export const PATH_SIGN_IN_LOGO = '/asset/Image/signIn/logo.png';
export const PATH_SIGN_IN_BUTTON = '/asset/Image/signIn/button.svg';
